import { DiagnosticsRingBuffer } from './ring-buffer.js'
import { sanitizeDiagnosticsEvent, type DiagnosticsEventInput } from './sanitizer.js'
import type { DiagnosticsEvent } from './ring-buffer.js'

/**
 * App diagnostics store — a single ring buffer fed only with sanitized events.
 * Sizes/retention: 14 days or 5 MB, whichever comes first (§15.5).
 */
export const diagnosticsBuffer = new DiagnosticsRingBuffer()

export function recordDiagnostic(
  input: Omit<DiagnosticsEventInput, 'timestamp'>,
  now: number = Date.now(),
): DiagnosticsEvent {
  const event = sanitizeDiagnosticsEvent({
    ...input,
    timestamp: new Date(now).toISOString(),
  })
  diagnosticsBuffer.add(event)
  return event
}

export function diagnosticsSizeLabel(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
